// Keep the single real form and its variant controls; never duplicate the cart action.
for (const root of document.querySelectorAll('[data-nc-product]')) {
  if (root.dataset.ncPurchaseReady) continue;
  const slot = root.querySelector('[data-nc-purchase-slot]');
  const purchase = root.querySelector('.nc-product__purchase');
  const gallery = root.querySelector('.nc-product__gallery');
  if (!slot || !purchase) continue;
  const options = purchase.querySelector('.nc-product__options');
  const selectionTitle = purchase.querySelector('.nc-product__selection-title');
  const offers = root.querySelector('[data-nc-offers]');
  // Move the existing controls within the same form; keep their listeners and IDs.
  const controlsHome = document.createComment('nc-variant-controls-home');
  if (options && offers) purchase.insertBefore(controlsHome, selectionTitle || options);
  const desktop = matchMedia('(min-width:901px)');
  // Keep colour and size immediately available; there is no collapsed mobile state.
  let frame = 0, naturalHeight = 0, photoNeedsFit = true;
  function setLength(name, value) {
    const pixels = `${Math.round(value)}px`;
    if (root.style.getPropertyValue(name) !== pixels) root.style.setProperty(name, pixels);
  }
  function fitPhoto() {
    if (!gallery) return;
    const stage = gallery.querySelector('.nc-product__stage');
    const firstImage = gallery.querySelector('[data-nc-media] img');
    if (!stage || !firstImage) return;
    const width = stage.getBoundingClientRect().width;
    const ratio = (firstImage.naturalHeight || Number(firstImage.getAttribute('height'))) / (firstImage.naturalWidth || Number(firstImage.getAttribute('width')));
    // Full-width portrait on desktop and mobile, at a stable natural aspect ratio.
    // No dependency on scroll position, viewport height or the purchase bar.
    const height = width * (ratio || 1.25);
    setLength('--nc-product-photo-height', height);
    setLength('--nc-gallery-height', height);
    photoNeedsFit = false;
  }
  function update() {
    frame = 0;
    if (!root.isConnected) return;
    if (options && offers) {
      const target = desktop.matches ? offers.parentElement : purchase;
      if (options.parentElement !== target) {
        const before = desktop.matches ? (root.querySelector('[data-nc-stock-widget]') || offers) : controlsHome;
        if (selectionTitle) target.insertBefore(selectionTitle, before);
        target.insertBefore(options, before);
        naturalHeight = purchase.getBoundingClientRect().height;
      }
    }
    if (!desktop.matches) {
      root.dataset.ncPurchaseFloating = 'false';
      slot.style.minHeight = '';
      if (photoNeedsFit) fitPhoto();
      return;
    }
    // Dock the desktop action in its own column, clear of the photograph.
    const column = slot.getBoundingClientRect();
    setLength('--nc-purchase-left', column.left);
    setLength('--nc-purchase-width', column.width);
    if (root.dataset.ncPurchaseFloating !== 'true') naturalHeight = purchase.getBoundingClientRect().height;
    const header = document.querySelector('.nc-header');
    const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
    const slotTop = slot.getBoundingClientRect().top;
    // Keep the controls visible both before their natural position enters the viewport
    // and after it scrolls above the header. The placeholder prevents layout feedback.
    const floating = slotTop < headerBottom + 8 || slotTop + naturalHeight > window.innerHeight - 14;
    if (floating && naturalHeight) slot.style.minHeight = `${naturalHeight}px`;
    root.dataset.ncPurchaseFloating = String(floating);
    if (!floating) slot.style.minHeight = '';
    if (photoNeedsFit) fitPhoto();
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  function scheduleLayout() { photoNeedsFit = true; schedule(); }
  window.addEventListener('scroll', schedule, {passive:true, capture:true});
  window.addEventListener('resize', scheduleLayout, {passive:true});
  window.addEventListener('pageshow', scheduleLayout);
  desktop.addEventListener('change', scheduleLayout);
  new ResizeObserver(scheduleLayout).observe(purchase);
  for (const image of gallery?.querySelectorAll('[data-nc-media] img') || []) image.addEventListener('load', scheduleLayout, {once:true});
  root.dataset.ncPurchaseReady = 'true';
  update();
}
